import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { WeblinkMainComponent } from './weblink-main/weblink-main.component';
import { CanNavigateToWeblinkGuard } from './shared/can-navigate-to-weblink.guard';
import { CanDeactivateWeblinkGuard } from './shared/can-deactivate-weblink.guard';

const routes: Routes = [ {
  path: '',
  component: WeblinkMainComponent
},
// {
//   path: 'weblink/:token',
//   component: WeblinkMainComponent,
//   canActivate: [ CanNavigateToWeblinkGuard ],
//   canDeactivate: [ CanDeactivateWeblinkGuard ]
// }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class WeblinkRoutingModule { }
